/*eslint no-magic-numbers: ["error", { "ignore": [0] }]*/
import React, { useContext, useState } from 'react'
import { useParams } from 'react-router-dom'

import Input from 'components/Input'
import Textarea from 'components/Textarea'
import { delay } from 'utils/delay'
import { requestUpdateSiteSpecieAssesmentParameter } from 'api/siteSpecieAssesmentParameter'
import { isValidDecimalNumber, noZeroAfterDecimal } from 'utils/isValidDecimalNumber'
import { SiteContext } from 'providers/site'
import { defaultSiteProposalValidationResults } from 'constants/defaultSiteProposalValidationResults'
import { SITE_STATUS_DRAFT_ID } from 'constants/siteStatuses'
import { minBestMaxValidation } from 'utils/minBestMaxValidation'
import { SpeciesDetailsContainer, SpeciesDetailsItemWrapper } from '../style'
import { NUMBER_OF_MATURE_INDIVIDUALS_ID, NUMBER_OF_LOCALITIES_ID } from 'constants/speciesParameterType'

const fields = {
  min: 'minGlobal',
  best: 'bestGlobal',
  max: 'maxGlobal'
}

const inputSaveDelayTime = 300
const updateSourceTimeOut = delay(inputSaveDelayTime)
const updateNotesTimeOut = delay(inputSaveDelayTime)
const SpeciesParameterGlobalDataContent = ({
  parameter,
  siteSpecieParameterId,
  updateParameterList,
  species,
  qualified,
  assessmentParameter,
  siteBestGlobal,
  setSiteBestGlobal,
  siteNatureOfOccurance,
  setSiteNatureOfOccurance,
  siteJustification, setSiteJustification
}) => {
  const params = useParams()
  const { site, siteProposalFieldValidation, isEditable } = useContext(SiteContext)
  const disabled = !parameter?.SiteAssesmentParameterTypeId || site.SiteStatusId !== SITE_STATUS_DRAFT_ID || !isEditable || !qualified

  const [minGlobal, setMinGlobal] = useState(parameter.minGlobal || '')
  const [bestGlobal, setBestGlobal] = useState(parameter.bestGlobal || '')
  const [maxGlobal, setMaxGlobal] = useState(parameter.maxGlobal || '')
  const [source, setSource] = useState(parameter.sourceGlobalData ? parameter.sourceGlobalData : '')
  const [notes, setNotes] = useState(parameter.notes || '')
  const [error, setError] = useState({ field: '', error: '' })

  // When iba_only is true, bestGlobal and sourceGlobalData become optional
  const isIbaOnly = parameter.iba_only === true

  const checkFields = siteProposalFieldValidation.assessmentParameters[parameter.id]
    ? siteProposalFieldValidation.assessmentParameters[parameter.id]
    : defaultSiteProposalValidationResults.assessmentParameters

  function handleChangeMinGlobal(e) {
    const errorMessage = minBestMaxValidation(e.target.value, bestGlobal, maxGlobal, fields, 'min')
    if (errorMessage.field !== '') {
      if (isValidDecimalNumber(Number(e.target.value))) {
        if (noZeroAfterDecimal(e.target.value)) {
          setMinGlobal(e.target.value)
          setError(errorMessage)
        }
      }
      return
    }
    if (isValidDecimalNumber(Number(e.target.value))) {
      if (noZeroAfterDecimal(e.target.value)) {
        setMinGlobal(e.target.value)
        setError(errorMessage)
      }
      let value = e.target.value
      if (((parameter.SiteAssesmentParameterTypeId === NUMBER_OF_MATURE_INDIVIDUALS_ID) || (parameter.SiteAssesmentParameterTypeId === NUMBER_OF_LOCALITIES_ID))) {
        value = Number(parseFloat(e.target.value).toFixed('0'))
      } else {
        value = Number(parseFloat(e.target.value).toFixed('10'))
      }
      requestUpdateSiteSpecieAssesmentParameter(siteSpecieParameterId, params.siteHistoryId, species.id, species.historyId, {
        minGlobal: e.target.value === '' ? null : value
      }).then(
        (data) => {
          updateParameterList(data)
        }
      )
    }
  }

  function shouldValidateField(fieldName) {
    if (qualified) {
      return checkFields[fieldName]
    }
    return true
  }


  function handleBlurMinGlobal(e) {
    if (((parameter.SiteAssesmentParameterTypeId === NUMBER_OF_MATURE_INDIVIDUALS_ID) || (parameter.SiteAssesmentParameterTypeId === NUMBER_OF_LOCALITIES_ID)) && e.target.value.includes('.')) {
      return
    }

    const errorMessage = minBestMaxValidation(e.target.value, bestGlobal, maxGlobal, fields, 'min')
    if (errorMessage.field !== '') {
      if (isValidDecimalNumber(Number(e.target.value))) {
        if (noZeroAfterDecimal(e.target.value)) {
          setMinGlobal(e.target.value)
          setError(errorMessage)
        }
      }
      return
    }
    if (isValidDecimalNumber(Number(e.target.value))) {
      if (noZeroAfterDecimal(e.target.value)) {
        setMinGlobal(e.target.value)
        setError(errorMessage)
      }
      const value = Number(parseFloat(e.target.value).toFixed('10'))
      requestUpdateSiteSpecieAssesmentParameter(siteSpecieParameterId, params.siteHistoryId, species.id, species.historyId, {
        minGlobal: e.target.value === '' ? null : value
      }).then(
        (data) => {
          updateParameterList(data)
        }
      )
    }
  }

  function handleChangeBestGlobal(e) {
    const errorMessage = minBestMaxValidation(minGlobal, e.target.value, maxGlobal, fields, 'best')
    if (errorMessage.field !== '') {
      if (isValidDecimalNumber(Number(e.target.value))) {
        if (noZeroAfterDecimal(e.target.value)) {
          setBestGlobal(e.target.value)
          setSiteBestGlobal(e.target.value)
          setError(errorMessage)
        }
      }
      return
    }
    if (isValidDecimalNumber(Number(e.target.value))) {
      if (noZeroAfterDecimal(e.target.value)) {
        setBestGlobal(e.target.value)
        setSiteBestGlobal(e.target.value)
        setError(errorMessage)
      }
      let value = e.target.value
      if (((parameter.SiteAssesmentParameterTypeId === NUMBER_OF_MATURE_INDIVIDUALS_ID) || (parameter.SiteAssesmentParameterTypeId === NUMBER_OF_LOCALITIES_ID)) && e.target.value.includes('.')) {
        value = Number(parseFloat(e.target.value).toFixed('0'))
      } else {
        value = Number(parseFloat(e.target.value).toFixed('10'))
      }
      requestUpdateSiteSpecieAssesmentParameter(siteSpecieParameterId, params.siteHistoryId, species.id, species.historyId, {
        bestGlobal: e.target.value === '' ? null : value
      }).then(
        (data) => {
          updateParameterList(data)
        }
      )
    }
  }

  function handleBlurBestGlobal(e) {
    if (((parameter.SiteAssesmentParameterTypeId === NUMBER_OF_MATURE_INDIVIDUALS_ID) || (parameter.SiteAssesmentParameterTypeId === NUMBER_OF_LOCALITIES_ID)) && e.target.value.includes('.')) {
      return
    }

    const errorMessage = minBestMaxValidation(minGlobal, e.target.value, maxGlobal, fields, 'best')
    if (errorMessage.field !== '') {
      if (isValidDecimalNumber(Number(e.target.value))) {
        if (noZeroAfterDecimal(e.target.value)) {
          setBestGlobal(e.target.value)
          setError(errorMessage)
        }
      }
      return
    }
    if (isValidDecimalNumber(Number(e.target.value))) {
      if (noZeroAfterDecimal(e.target.value)) {
        setBestGlobal(e.target.value)
        setError(errorMessage)
      }
      const value = Number(parseFloat(e.target.value).toFixed('10'))
      requestUpdateSiteSpecieAssesmentParameter(siteSpecieParameterId, params.siteHistoryId, species.id, species.historyId, {
        bestGlobal: e.target.value === '' ? null : value
      }).then(
        (data) => {
          updateParameterList(data)
        }
      )
    }
  }

  function handleChangeMaxGlobal(e) {
    const errorMessage = minBestMaxValidation(minGlobal, bestGlobal, e.target.value, fields, 'max')
    if (errorMessage.field !== '') {
      if (isValidDecimalNumber(Number(e.target.value))) {
        if (noZeroAfterDecimal(e.target.value)) {
          setMaxGlobal(e.target.value)
          setError(errorMessage)
        }
      }
      return
    }
    if (isValidDecimalNumber(Number(e.target.value))) {
      if (noZeroAfterDecimal(e.target.value)) {
        setMaxGlobal(e.target.value)
        setError(errorMessage)
      }
      let value = e.target.value
      if (((parameter.SiteAssesmentParameterTypeId === NUMBER_OF_MATURE_INDIVIDUALS_ID) || (parameter.SiteAssesmentParameterTypeId === NUMBER_OF_LOCALITIES_ID))) {
        value = Number(parseFloat(e.target.value).toFixed('0'))
      } else {
        value = Number(parseFloat(e.target.value).toFixed('10'))
      }
      requestUpdateSiteSpecieAssesmentParameter(siteSpecieParameterId, params.siteHistoryId, species.id, species.historyId, {
        maxGlobal: e.target.value === '' ? null : value
      }).then(
        (data) => {
          updateParameterList(data)
        }
      )
    }
  }
  function handleBlurMaxGlobal(e) {
    if (((parameter.SiteAssesmentParameterTypeId === NUMBER_OF_MATURE_INDIVIDUALS_ID) || (parameter.SiteAssesmentParameterTypeId === NUMBER_OF_LOCALITIES_ID)) && e.target.value.includes('.')) {
      return
    }

    const errorMessage = minBestMaxValidation(minGlobal, bestGlobal, e.target.value, fields, 'max')
    if (errorMessage.field !== '') {
      if (isValidDecimalNumber(Number(e.target.value))) {
        if (noZeroAfterDecimal(e.target.value)) {
          setMaxGlobal(e.target.value)
          setError(errorMessage)
        }
      }
      return
    }
    if (isValidDecimalNumber(Number(e.target.value))) {
      if (noZeroAfterDecimal(e.target.value)) {
        setMaxGlobal(e.target.value)
        setError(errorMessage)
      }
      const value = Number(parseFloat(e.target.value).toFixed('10'))
      requestUpdateSiteSpecieAssesmentParameter(siteSpecieParameterId, params.siteHistoryId, species.id, species.historyId, {
        maxGlobal: e.target.value === '' ? null : value
      }).then(
        (data) => {
          updateParameterList(data)
        }
      )
    }
  }

  function handleChangeSource(e) {
    setSource(e.target.value)

    updateSourceTimeOut(() => {
      requestUpdateSiteSpecieAssesmentParameter(siteSpecieParameterId, params.siteHistoryId, species.id, species.historyId, { sourceGlobalData: e.target.value }).then(
        (data) => {
          updateParameterList(data)
        }
      )
    })
  }

  function handleChangeNotes(e) {
    setNotes(e.target.value)

    updateNotesTimeOut(() => {
      requestUpdateSiteSpecieAssesmentParameter(siteSpecieParameterId, params.siteHistoryId, species.id, species.historyId, { notes: e.target.value }).then((data) => {
        updateParameterList(data)
      })
    })
  }

  return (
    <SpeciesDetailsContainer noPadding={true}>
      <SpeciesDetailsItemWrapper>
        <Input
          value={minGlobal}
          onChange={handleChangeMinGlobal}
          onBlur={handleBlurMinGlobal}
          placeholder='enterSpeciesMinGlobalData'
          label='minGlobal'
          field='minGlobal'
          infoTooltip='minGlobalHint'
          zIndex='1070'
          disabled={disabled}
          isOptional={true}
          error={error.field === 'minGlobal' ? error : { field: '', error: '' }}
          errorMarginTop='8px'
        />
      </SpeciesDetailsItemWrapper>
      <SpeciesDetailsItemWrapper>
        <Input
          value={bestGlobal}
          onChange={handleChangeBestGlobal}
          onBlur={handleBlurBestGlobal}
          placeholder='enterSpeciesBestGlobalData'
          label='bestGlobal'
          field='bestGlobal'
          infoTooltip='bestGlobalHint'
          zIndex='1070'
          isOptional={siteNatureOfOccurance || isIbaOnly}
          disabled={disabled}
          link={'info@keybiodiversityareas.org'}
          errorMarginTop='8px'
          error={
            isIbaOnly || shouldValidateField('bestGlobal')
              ? (error.field === 'bestGlobal'
                ? error
                : {
                  field: '',
                  error: ''
                })
              : { field: 'bestGlobal', error: 'pleaseCompleteThisField' }
          }
        />
      </SpeciesDetailsItemWrapper>
      <SpeciesDetailsItemWrapper>
        <Input
          value={maxGlobal}
          onChange={handleChangeMaxGlobal}
          onBlur= {handleBlurMaxGlobal}
          placeholder='enterSpeciesMaxGlobalData'
          label='maxGlobal'
          field='maxGlobal'
          infoTooltip='maxGlobalHint'
          zIndex='1070'
          disabled={disabled}
          isOptional={true}
          errorMarginTop='8px'
          error={error.field === 'maxGlobal' ? error : { field: '', error: '' }}
        />
      </SpeciesDetailsItemWrapper>
      <div style={{ width: '100%' }}>
        <Textarea
          value={source}
          onChange={handleChangeSource}
          placeholder='enterSpeciesGlobalSourceData'
          label='sourceGlobal'
          field='sourceGlobalData'
          infoTooltip='globalDataSourceHint'
          zIndex='1070'
          height='128px'
          disabled={disabled}
          errorMarginTop='8px'
          isOptional={isIbaOnly}
          // For sourceGlobalData field
          error={
            isIbaOnly || shouldValidateField('sourceGlobalData')
              ? {
                field: '',
                error: ''
              }
              : { field: 'sourceGlobalData', error: 'pleaseCompleteThisField' }
          }

        />
      </div>
      <div style={{ width: '100%' }}>
        <Textarea
          value={notes}
          onChange={handleChangeNotes}
          placeholder='enterNotesOnSpeciesGlobalData'
          label='notes'
          infoTooltip='globalDataNoteHint'
          zIndex='1070'
          height='128px'
          disabled={disabled}
          isOptional={true}
        />
      </div>
    </SpeciesDetailsContainer>
  )
}

export default SpeciesParameterGlobalDataContent
